export function initLegacy(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>) {
   $(function () {
      const xppViewModel = window.xppViewModel = new XPP.ViewModel(model);

      ko.applyBindings(xppViewModel, document.getElementById("xpp"));
      ko.applyBindings(xppViewModel, document.getElementById("xpp-pinned"));

      LSHelper.HelperLib.navigateToAnchor({
         customHashRules: {
            "#spaces-monthly": function () {
               if (xppViewModel.monthlyWorkspacesCount > 0)
                  xppViewModel.spaceTypeDisplayMode("monthly");
               return true;
            },
            "#spaces-membership": function () {
               if (xppViewModel.membershipWorkspacesCount > 0)
                  xppViewModel.spaceTypeDisplayMode("membership");
               return true;
            },
            "#spaces-hourly": function () {
               if (xppViewModel.hourlyWorkspacesCount > 0)
                  xppViewModel.spaceTypeDisplayMode("hourly");
               return true;
            }
         }
      });

      if (model.CompleteBookingModel != null) {
         LSHelper.Account.popUpSignIn({
            joinMessage: "Sign up to book " + model.VenueFullName + ".",
            signInMessage: "Log in to book " + model.VenueFullName + ".",
            popupParams: {
               mode: model.CompleteBookingModel.Mode as LiquidSpace.View.LogonPopupMode,
               email: model.CompleteBookingModel.Email,
               fullName: model.CompleteBookingModel.FullName
            }
         });
      }
      else if (model.VenueStatusNew == LSCrossTier.VenueStatusNew.Internal && User.isAnonymous()) {
         const mode: LiquidSpace.View.LogonPopupMode = LSHelper.HelperLib.getURLParameter("m") == "join"
            ? "join"
            : "signin";
         LSHelper.Account.popUpSignIn({
            joinMessage: "This location is visible to members only. Please sign up to view availability and book a reservation.",
            signInMessage: "This location is visible to members only. Please log in to view availability and book a reservation.",
            popupParams: {
               mode: mode,
            }
         });
      }

      if (model.VenueIsExtended) {
         //extended XPP tracking
         LiquidSpaceConfig.SupportedCountries.indexOf(model.VenueCountry?.toLowerCase() ?? null) == -1
            ? LSHelper.ga.trackVPV({ pageName: "/vpv/venue-extended-international" })
            : LSHelper.ga.trackVPV({ pageName: "/vpv/venue-extended" });
      }
   });
}
